const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.29 32.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.25.11A1.39,1.39,0,0,0,20.9.25l-12.41,9H2.55A2.44,2.44,0,0,0,0,11.55v9.24A2.44,2.44,0,0,0,2.55,23.1H8.49l12.41,9a1.4,1.4,0,0,0,.8.25,1.3,1.3,0,0,0,.55-.12,1.15,1.15,0,0,0,.73-1v-30A1.17,1.17,0,0,0,22.25.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.44,9.57a1.63,1.63,0,0,0-1.8,0,.77.77,0,0,0-.26,1.06.87.87,0,0,0,.27.27,6.15,6.15,0,0,1,0,10.55.76.76,0,0,0-.27,1.05.75.75,0,0,0,.26.27,1.63,1.63,0,0,0,1.8,0,7.69,7.69,0,0,0,0-13.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,5.66a1.47,1.47,0,0,0-1.81,0A.94.94,0,0,0,31.06,7a.77.77,0,0,0,.18.18,11.24,11.24,0,0,1,2.24,15.75,11.11,11.11,0,0,1-2.24,2.25.93.93,0,0,0-.18,1.32,1,1,0,0,0,.17.18,1.49,1.49,0,0,0,1.81,0,13.14,13.14,0,0,0,2.62-18.4A13,13,0,0,0,33,5.65Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.769e10789f3d6f2e681c64ceefd9b109.svg";
export { ForwardRef as ReactComponent };